var _g, _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinPremier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11.9502,
    cy: 12.1387,
    r: 10,
    fill: "white",
    stroke: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.60156,
    y: 2.51953,
    width: 9.78473,
    height: 18.4119,
    rx: 3,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.450195,
    y: 0.638672,
    width: 25,
    height: 25,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(-5.52519) scale(0.022009 0.0116964)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 398,
    height: 127,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAY4AAAB/CAMAAADPY9VGAAAAyVBMVEX////2fBHzehf4fQ39gQP2fBL+ggH//Pj97+jubQDudiH1eQv2iTj7gAb5fwrzcQD+9/P4omXzgiv8zqz74NT+egD2dwD62cX+9e3zjU3xexbtbQD+dwD+6tf7fAD+8ufvchT50br+u4z+snf+toH+38L+iAv+lzz+nEj+xpv9qGL9rGf+2Lf8iyj8rXH8snz7oFX9xqL7r3r7uof5hx/+69z4kUT5m136v5n5s4T2llj3pnP1k0z6yanxjFDwh0XwfS30r4j2vZtn+cF2AAADiUlEQVR4nO3bbVeiQBwFcAQVFQWfGDBpBKtta7OywtW0Lfv+H2pnoAdA9y1/9sz9nU5hr+7hnmFmADUNAAD+P+ZofnY+v6COAYm563Ih+IFC6PUv3eaH4Jw6jPLMn7z5JbiijqO6K7eZEZxS51GbX8+20eTX1IHUFrnNekbTNakTKe2M13MCrK4oXRfqcG+oEyntF+qokvPixQpLK0oer/cy6nXqQGozFzxbB7+jDqS4GzczPOquT51HdbfudxsBJnJyd246f9Q5H1FnAU27WHCXi5/7mDoJJE6j9TKaUacAqBhToM4AqdnjIgiC3v2yT50ENG3JObdtu8fdHtZU5EZBz/7QC7AdJ2Z2v9oQ8JicWJxtw7YZ5g9SEcvXgemDgP9wuUyPHgt1bGiDqWkU8Kf0tu2OGzkMd3PL5zHDTs672S3WMafOpqAxs3lydyruGQU9TOali5nhJHduxTApYGvqcOqJucE8eXB1UIdh4+5V2WZPRrqkHRzWwZbU6ZTjdw0mN+AHM7n0RJ1OOeaKM/k1jlntsA3DwVawbL8Z22pyhXWkDmNBnU45A8YGmpzJazlG8pvNRwk8NS/LA2M7U7ZSO4alnHts0csxZ9ZQ7PdWRr6Gx8LnFXVORYzEsPDlejd3+h1zlx8uDrbopfCcGmuJmTx38q2u2KXn68DVqhRjp+G0xBhpZMnF1ir7L4tR51REbDccT7st1LHWtNMhy/CocypidmKJ3d6OWVmOPPv+evBpjlcSS+IPLbY0V92cE0zcRMyVxTbJy4dZ1KnU9Wyxbb+Vg1UUnQFrDBtOjr3DzE3lgemNhp5nOS/UsVS1ZvqhhoO1FI0X50gduoMH5TSOjg49uesO5ftHHVvqXIryjl+sMJfTMJ+PDA8L+3IqcdexiutcfUydSl399aQ7FGQT8u9wssEyl5Qv9F91/SSWR9RpQJqIOjBlVAbqqBTUUSmoo1JQR6WgjkpBHZWCOiplEqKOCpmEHR11VMYf1FElog5crKoDdVSEP5Zew07Hkwct6jxKM/dv07bQEeTB9G2LQUJnkxQRthOhPG7jxQUyrU7SxtZLbJM+phgeVOKkgHCfftqkwwN1UDHlFN5pR+mnaCrreMNXCsh402nYHnwWMGiH4RRvsBOK3/fR93CI9u9Y6QIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAADAEX8BH0FNteatIL8AAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPremier);
export default __webpack_public_path__ + "static/media/pin_premier.edb8d788b78c618f1905b0aec6c8108a.svg";
export { ForwardRef as ReactComponent };